var _excluded = ["isActive", "activeColor", "onClick", "title", "value", "before", "borderRadius", "backgroundColor", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import transition from "../../../utils/transition";
import unit from "../../../utils/unit";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
export var defaultProps = {
  activeColor: "success",
  borderRadius: "medium"
};
var defaultBorderSize = 1;
var getShadowBorder = function getShadowBorder(width, color) {
  return "0 0 0 ".concat(unit(width), " ").concat(color, " inset");
};
var StyledSelectButtonAtm = styled.button.withConfig({
  componentId: "sc-h247og-0"
})(function (_ref) {
  var $isActive = _ref.$isActive,
    $activeColor = _ref.$activeColor,
    $hasBefore = _ref.$hasBefore,
    $onColor = _ref.$onColor,
    theme = _ref.theme,
    $borderRadius = _ref.$borderRadius,
    $backgroundColor = _ref.$backgroundColor;
  return css(["", ";", ";min-width:", ";padding:", " ", ";border:0;border-radius:", ";background:none;box-shadow:", ";cursor:pointer;&:hover{box-shadow:", ";}", " ", " ", ""], cssTextAtm({
    typography: "xsmall1",
    onColor: $onColor,
    emphasis: $isActive ? "high" : "medium"
  }), transition("color", "box-shadow"), space(8), space(1), space(2), getBorderRadius(theme, $borderRadius), getShadowBorder(defaultBorderSize, getBorderColor(theme, $onColor, "medium")), getShadowBorder(defaultBorderSize, getBorderColor(theme, $onColor, "high")), $isActive && css(["box-shadow:", " !important;cursor:initial;"], getShadowBorder(2, getColor(theme, $activeColor))), $hasBefore && css(["display:flex;align-items:center;> *:first-child{margin-right:", ";}"], space(1)), $backgroundColor ? css(["background-color:", ";"], getColor(theme, $backgroundColor)) : null);
});
function SelectButtonAtm(_ref2) {
  var isActive = _ref2.isActive,
    _ref2$activeColor = _ref2.activeColor,
    activeColor = _ref2$activeColor === void 0 ? defaultProps.activeColor : _ref2$activeColor,
    onClick = _ref2.onClick,
    title = _ref2.title,
    value = _ref2.value,
    before = _ref2.before,
    _ref2$borderRadius = _ref2.borderRadius,
    borderRadius = _ref2$borderRadius === void 0 ? defaultProps.borderRadius : _ref2$borderRadius,
    backgroundColor = _ref2.backgroundColor,
    children = _ref2.children,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledSelectButtonAtm, _extends({
    onClick: onClick,
    title: title,
    value: value,
    type: "button",
    $isActive: !!isActive,
    $activeColor: activeColor,
    $hasBefore: !!before,
    $onColor: onColor,
    $borderRadius: borderRadius,
    $backgroundColor: backgroundColor
  }, restProps), before, children);
}
export default SelectButtonAtm;